import {
	connect
} from 'react-redux'
import LabelOtherComponent from '../components/LabelOtherComponent.jsx';
import {
	generateOtherLabel,
	changeOtherLabelValue,
	cleanOtherLabelAlert,
	findModelNosBySizeType
} from '../actions';

const mapStateToProps = (state) => ({
	otherLabel: state.getIn(['otherLabelReducer', 'otherLabel']),
	otherLabelValidation: state.getIn(['otherLabelReducer', 'otherLabelValidation']),
	alertStyle: state.getIn(['otherLabelReducer', 'alertStyle']),
	alertMessage: state.getIn(['otherLabelReducer', 'alertMessage']),
	templateList: state.getIn(['otherLabelReducer', 'templateList']),
})

const mapDispatchToProps = (dispatch) => ({
	generateOtherLabel: (otherLabel) => {
		dispatch(generateOtherLabel(otherLabel))
	},
	setValue: (id, value) => {
		dispatch(changeOtherLabelValue({
			id: id,
			value: value
		}))
	},
	cleanAlert: () => {
		dispatch(cleanOtherLabelAlert());
	},
	findOtherTemplateList: (payload) => {
		dispatch(findModelNosBySizeType(payload.sizeType));
	}
})

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
	otherLabel: stateProps.otherLabel,
	otherLabelValidation: stateProps.otherLabelValidation,
	alertStyle: stateProps.alertStyle,
	alertMessage: stateProps.alertMessage,
	templateList: stateProps.templateList,
	generateOtherLabel: () => dispatchProps.generateOtherLabel(stateProps.otherLabel),
	setValue: dispatchProps.setValue,
	cleanAlert: dispatchProps.cleanAlert,
	findOtherTemplateList: dispatchProps.findOtherTemplateList
})

const LabelContainer = connect(
	mapStateToProps,
	mapDispatchToProps,
	mergeProps
)(LabelOtherComponent)

export default LabelContainer;


// WEBPACK FOOTER //
// ./src/containers/LabelOtherContainer.jsx